<template>
    <div class="imports">
        <h1><i class="fa fa-file" /> IMPORTAÇÕES</h1>
        <div class="toa mod">
            <div class="title row align-center justify-space">
                <div class="row align-center">TOA <img src="../../assets/img/claro.png" />
                    <button @click="tutorial = !tutorial" class="tut">Tutorial <i v-if="tutorial"
                            class="fa fa-chevron-up" /><i v-else class="fa fa-chevron-down" /></button>
                </div>
                <Button onclick="document.getElementById('attach').click()" layout="green-go">Importar</Button>
            </div>
            <div v-if="tutorial" class="tutorial">
                <div class="desc row column-s wrap justify-space">
                    <div class="step grid-2 grid-12-s">
                        <div class="st">Passo 1</div>
                        <b>Acesse:</b><br /> &nbsp;<a href="https://clarobrasil.etadirect.com/mobility"
                            target="_blank">https://clarobrasil.etadirect.com/mobility</a><br /><br />
                        <img width="220" src="../../assets/img/toa-login.png" />
                    </div>
                    <div class="step grid-4 grid-12-s">
                        <div class="st">Passo 2</div>
                        Escolha a <b>Data</b> para qual deseja realizar a exportação.<br />
                        <img src="../../assets/img/toa-data.jpg" />
                    </div>
                    <div class="step grid-4 grid-12-s">
                        <div class="st">Passo 3</div>
                        Vá até a aba <b>Ações</b> e clique em <b>Exportar</b><br />
                        <img src="../../assets/img/toa-exportar.jpg" />
                    </div>
                </div>
            </div>
            <div v-if="files.length" class="files">
                <div class="upload row align-center grid-12">Upload <Button :loader="loader"
                        v-if="files.length > 0 && files.filter(f => f.notallow).length == 0" @click="submit"
                        layout="green-go">ENVIAR</Button></div>
                <div v-for="(f, i) in files" :key="'f'+i" class="file row align-center">
                    <button @click="files.splice(i, 1)" class="del" title="Excluir"><i class="fa fa-trash" /></button>
                    <div v-if="!f.notallow" class="field grid-8 grid-6-s">
                        <div class="filler row justify-end" :style="`width: ${f.percent}%`"> {{ f.percent + "%" }}</div>
                    </div>
                    <div v-else class="notallow">{{ f.notallow && 'Formato de arquivo não permitido.' }}</div>
                    {{ f.name }}
                </div>
            </div>
            <input id="attach" type="file" ref="files" @change="loadFile" class="hide" multiple />
        </div>
        <!-- <Modal :modal="modal"></Modal> -->
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
/* import Modal from "@/components/Modal"; */
/* import FlagForm from "@/views/admin/components/FlagForm.vue"; */

export default {
    name: "Imports",
    components: {
        Button
    },
    data() {
        return {
            loader: false,
            tutorial: false,
            files: [],
        };
    },
    methods: {
        ...mapActions("admin", ["TOA"]),
        loadFile(f) {
            var files = f.target.files || f.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                if (!this.files[i]) this.files[i] = { percent: 0, name: files[i].name }
                if (files[i].type.match("application/vnd.openxmlformats-officedocument.spreadsheetml.shee")) {
                    let reader = new FileReader();
                    reader.readAsDataURL(files[i]);
                    reader.onprogress = (e) => {
                        if (e.lengthComputable) {
                            this.files[i].percent = Math.round((e.loaded / e.total) * 100)
                            this.files = [...this.files]
                        }
                    }
                    reader.onload = (e) => (this.files[i].file = e.target.result, this.files[i].percent = 100, this.files = [...this.files])
                } else
                    this.files[i].notallow = true
            }
        },
        async submit() {
            let arquivos = []
            this.files.map(f => arquivos.push(f.file.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,','')))
            this.loader = true;
            await this.TOA({ arquivos: arquivos })
            this.files = []
            this.loader = false;
        },
    },
    mounted() {
        this.$parent.$children[0].changeMenu("imports");
    },
    computed: {
    },
};
</script>

<style lang="sass" scoped>
  @use "@/assets/scss/vars.scss" as *
  .imports
      @include page
      .mod
        padding: 6px 12px
        background: white
        border-radius: 8px
        margin-top: 25px
        @include border
        .title
            padding: 12px 6px
            font-size: 24px
            img
                width: 25px
                margin-left: 6px
            .tut
                font-size:14px
                margin-left: 12px 
                color: $blue-2
                background: none
        .tutorial
            border-top: 1px solid #ddd
            margin-top: 6px
            padding: 0 12px
            padding-top: 20px
            img
                border-radius: 8px
            .step
                border-radius: 6px
                background: #f1f1f1
                padding: 10px
                margin: 0 4px
                font-weight: bold
                @include border
                margin-bottom: 20px
                .st
                    color: $orange-1
                    font-size: 21px
                    margin-bottom: 10px
                img
                    margin-top: 10px
                    width: 100%
            .title
                color: $blue-2
                font-size: 23px
                margin-bottom: 10px
                font-weight: bold
            .desc
                padding: 0 12px
                font-size: 14px
        .files
            margin-top: 25px
            font-size: 14px
            color: $font-color
            border-radius: 12px
            @include border()
            button
                font-size: 11px
                margin-left: 10px
                margin-top: 2px
            .upload
                font-size: 24px
                color: $green
                margin: 8px 12px
            .file
                padding: 10px
                &:nth-child(even)
                    background: #f1f1f1
                .del
                    color: #666
                    font-size: 16px
                    background: none
                    margin-right: 8px
                    margin-left: -2px
                    &:hover
                        color: $red
                .notallow
                    color: $red-1
                    font-size: 11px
                    margin-right: 10px
            .field 
                height: 15px
                width: 200px
                background: #444
                border: 1px solid #dbdbdb
                border-radius: 50px
                overflow: hidden
                margin-right: 10px
                .filler 
                    height: 100%
                    font-weight: bold
                    background: linear-gradient(90deg, $green-6 0%, $green-2 50%) 
  </style>